export const hyperlink_text =
  'Have you lost someone to Covid-19? Learn about eligibility for financial assistance.';
